// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"709":"faa979ba","731":"46b0736a","905":"1017ee85"}[chunkId] + ".chunk.js";
};